import script from "./StepPracticeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StepPracticeForm.vue?vue&type=script&setup=true&lang=js"

import "./StepPracticeForm.vue?vue&type=style&index=0&id=4d040a8e&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d040a8e"]])

export default __exports__